<template>
<x-y-chart
  v-if="currentDataConfig"
  :data-config="currentDataConfig"
  :unit-prop="unitProp"
  chart-type="groupChartType"
  :stack-type="0"
  :download-name="downloadName"
  :chart-min-height="chartMinHeight"
  :chart-height="chartHeight"
  :click-handler="onChartClick"
  selected-change-with-data-changed
  need-resize
>
  <template #toolbar-after>
    <el-button
      :disabled="!currentDataConfig.parentId || (!isShowTotal && currentDataConfig.parentId === 'VOCsTotal')"
      size="small"
      @click="onBackBtnClick"
    >返回</el-button>
  </template>
</x-y-chart>
</template>

<script>
import XYChart from '../../DataChart/XYChart'

const ROOT_ID = 'VOCsTotal'

export default {
  name: 'VocChart',
  components: {XYChart},
  props: {
    dataConfig: {
      required: true,
      type: Object
    },
    unitProp: {
      required: true,
      type: String
    },
    factorGroupMap: {
      required: true,
      type: Object
    },
    downloadName: {
      type: String
    },
    chartMinHeight: {
      type: String
    },
    chartHeight: {
      type: String
    },
    groupChartType: {
      type: String,
      default: 'bar'
    },
    defaultShow: {
      type: String,
      default: ROOT_ID
    },
    currentLevel: {
      type: Boolean
    },
    isShowTotal: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    dimensionMap: Object.freeze({}),
    currentDataConfig: null
  }),
  methods: {
    onChartClick (param) {
      let dataConfig = this.dimensionMap[param.seriesId]

      if (dataConfig) {
        this.currentDataConfig = dataConfig
      }
    },
    onBackBtnClick () {
      let dataConfig = this.dimensionMap[this.currentDataConfig.parentId]

      if (dataConfig) {
        this.currentDataConfig = dataConfig
      }
    }
  },
  watch: {
    dataConfig: {
      immediate: true,
      handler (dataConfig) {
        let {id, dimensions, dataTimes, seriesMap} = dataConfig
        let dataTimesLen = dataTimes.length
        let {factorGroupMap} = this
        let newSeriesMap = {...seriesMap}

        let groupMap = {}
        let tmp = [...dimensions]

        for (let i = 0; i < tmp.length; i++) {
          let dimension = tmp[i]
          let {parentId, id: dimensionId} = dimension
          let groupData = groupMap[parentId]

          if (!groupData) {
            let factorGroup = factorGroupMap[parentId]
            let newId, name, groupParentId, chartType

            if (factorGroup) {
              newId = parentId
              let factorGroupParentId = factorGroup.parentId

              if (parentId === id) {
                groupParentId = ROOT_ID
                chartType = 'line'
              } else {
                groupParentId = factorGroupParentId
                chartType = dimension.seriesParam.type
              }

              name = `${factorGroup.name}`
              newSeriesMap[parentId] = {}
            } else if (dimensionId === id) {
              newId = ROOT_ID
              name = 'VOCs总量'
              groupParentId = null
            } else {
              break
            }

            groupData = groupMap[newId] = Object.freeze({
              id: newId,
              name,
              dataTimes,
              dimensions: [],
              seriesMap: newSeriesMap,
              parentId: groupParentId,
              stdUnit: dimension.stdUnit,
              displayUnit: dimension.displayUnit,
              seriesParam: {
                type: chartType,
                showSymbol: false,
                symbolSize: 20,
                stack: dimension.seriesParam.stack
              }
            })

            tmp.push(groupData)
          }

          groupData.dimensions.push(dimension)

          if (dimensionId === id) {
            break
          }

          let seriesData = newSeriesMap[dimensionId]
          let parentSeriesData = newSeriesMap[parentId]

          for (let j = 0; j < dataTimesLen; j++) {
            let [ts, dataTime] = dataTimes[j]
            let data = seriesData[dataTime]

            if (data) {
              let parentData = parentSeriesData[dataTime]

              if (!parentData) {
                parentData = parentSeriesData[dataTime] = {
                  ts,
                  dataTime,
                  isHaveIntegral: false,
                  value: null
                }
              }

              if (data.isHaveIntegral) {
                parentData.isHaveIntegral = data.isHaveIntegral
              }

              const { value } = data
              if (Number.isFinite(value)) {
                if (Number.isFinite(parentData.value)) {
                  parentData.value += value
                } else {
                  parentData.value = value
                }
              }
            }
          }
        }

        this.dimensionMap = Object.freeze(groupMap)
        if (this.isShowTotal) {
          this.currentDataConfig = groupMap[this.currentLevel && this.currentDataConfig ? this.currentDataConfig.id : this.defaultShow]
        } else {
          this.currentDataConfig = groupMap['m30000']
        }
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/ChartWrapper/VOCChart.vue